module.exports = require("core-js/library/fn/json/stringify");


//////////////////
// WEBPACK FOOTER
// external "core-js/library/fn/json/stringify"
// module id = 7
// module chunks = 0